export default "/static/build/help.webp";